import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";

import { useIsMobile } from "../../hooks/is.mobile";
import { AudioPlayer } from "../../components/audio.track";
import { ImportAll } from "../../utils/utils";
import { Clickable } from "../../components/clickable.container";
import { useNavigate } from "react-router-dom";
import backIcon from "../../assets/back.png";

const efx = ImportAll(
  require.context("../../assets/audio/efx", false, /\.(mp3|wav|ogg)$/)
);

const music = ImportAll(
  require.context("../../assets/audio/music", false, /\.(mp3|wav|ogg)$/)
);

export const Audio: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      <div>
        {isMobile ? (
          <Clickable
            backgroundUrl={backIcon}
            onclick={() => {
              navigate("/services");
            }}
            style="back"
          />
        ) : (
          ""
        )}
        <div className={"title-text-font" + " " + "text-align" + " " + "title"}>
          Soundscapes That Speak
        </div>
      </div>
      <div
        style={{
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "6vw" : "2.5vw",
          paddingBottom: isMobile ? "6vw" : "2vw",
        }}
      >
        <p className="simple-text">
          Great games need great sound. Our audio design brings your world to
          life with immersive sound effects, dynamic ambience, and memorable
          music tailored to fit your game’s unique vibe. From subtle
          environmental sounds to epic action cues, we create audio that
          enhances gameplay and deepens player engagement.
        </p>
        <p className="simple-text">
          Every sound is carefully designed and mixed to complement your visuals
          and gameplay, ensuring a polished, professional experience. Check out
          the samples below and hear how our audio can transform your project.
        </p>
      </div>

      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Music
      </div>

      {music.map((src: any, i: number) => (
        <AudioPlayer key={i} src={src} />
      ))}

      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Efx
      </div>

      {efx.map((src: any, i: number) => (
        <AudioPlayer key={i} src={src} />
      ))}

      <div
        className={
          "title-text-font" + " " + "text-align" + " " + "optional-text"
        }
      >
        Ready to hear your vision? Get in touch, and let’s create something
        unforgettable together.
      </div>
    </div>
  );
};
